import { DEFAULT_LOCALE, i18n, type Locale } from "@redotech/redo-i18n";
import { setLocaleCookie } from "@redotech/redo-i18n/locale-cookie";
import { localizationConfig } from "@redotech/redo-i18n/localization-config";
import { parseLocale } from "@redotech/redo-i18n/resolve-shopper-locale";
import { ONBOARDING_LOCALE_PARAM } from "@redotech/redo-onboarding-api/locale-param";

export function parseLinkLocale(search: string): Locale | undefined {
  return parseLocale(new URLSearchParams(search).get(ONBOARDING_LOCALE_PARAM));
}

/**
 * Runs before `initI18n`. Merchant localization is always on, as in the
 * dashboard, so the first render resolves cookie and browser languages, and a
 * handoff link's language takes the cookie's place and stays applied.
 */
export function primeSetupLocalization(search: string): void {
  localizationConfig.setEnabled(true);
  const linkLocale = parseLinkLocale(search);
  if (linkLocale) {
    setLocaleCookie(linkLocale);
  }
}

/**
 * Resolves once the starting language's bundle has loaded, so the first render
 * is not English for a non-English merchant. Gives up after `timeoutMs`.
 */
export function waitForInitialLocale(timeoutMs: number): Promise<void> {
  return new Promise((resolve) => {
    const isReady = () =>
      i18n.isInitialized &&
      (i18n.language === DEFAULT_LOCALE ||
        i18n.hasResourceBundle(i18n.language, "translation"));
    const done = () => {
      clearTimeout(timeout);
      i18n.off("initialized", check);
      i18n.off("languageChanged", check);
      resolve();
    };
    const check = () => {
      if (isReady()) {
        done();
      }
    };
    const timeout = setTimeout(done, timeoutMs);
    i18n.on("initialized", check);
    i18n.on("languageChanged", check);
    check();
  });
}
